export var getValuesWithout = function getValuesWithout(array, substring) {
  return array.filter(function (i) {
    return !String(i.value).includes(substring);
  });
};
export var getValuesContaining = function getValuesContaining(array, substring) {
  return array.filter(function (i) {
    return String(i.value).includes(substring);
  });
};
export var filterOutDuplicateObjects = function filterOutDuplicateObjects(array, value) {
  return array.filter(function (i) {
    return String(i.value) !== value;
  });
};
export var orderByStartDate = function orderByStartDate(array) {
  var nullStartDate = array.filter(function (i) {
    return i.start_date === null;
  });
  return array.filter(function (i) {
    return i.start_date !== null;
  }).sort(function (a, b) {
    var aDateArray = a.start_date.split('-').map(function (x) {
      return Number(x);
    });
    var bDateArray = b.start_date.split('-').map(function (x) {
      return Number(x);
    });
    // Subtracted 1 to get the correct month;
    var aDate = new Date(aDateArray[0], aDateArray[1] - 1, aDateArray[2]);
    var bDate = new Date(bDateArray[0], bDateArray[1] - 1, bDateArray[2]);
    return bDate - aDate;
  }).concat(nullStartDate);
};
export var sum = function sum(lineItems, isEmployer) {
  if (lineItems) {
    if (isEmployer) {
      return lineItems.reduce(function (s, lineItem) {
        return s + (lineItem.gross_total || 0);
      }, 0);
    }
    return lineItems.reduce(function (s, lineItem) {
      return s + (lineItem.total || 0);
    }, 0);
  }
  return 0;
};
export var sumTime = function sumTime(lineItems) {
  if (lineItems && lineItems.length > 0) {
    var hours = lineItems.reduce(function (s, lineItem) {
      return s + lineItem.hours;
    }, 0);
    var minutes = lineItems.reduce(function (s, lineItem) {
      return s + lineItem.minutes;
    }, 0);
    if (minutes >= 60) {
      hours += parseInt(minutes / 60, 10);
      minutes %= 60;
    }
    var total = {
      hours: hours,
      minutes: minutes
    };
    return total;
  }
  return {
    hours: 0,
    minutes: 0
  };
};